<template><div><h1>实验室</h1>
<blockquote>
<p>beta 测试组件将出现在这里。</p>
</blockquote>
<ul>
<li><a href="/en/components/v-chart.html">VChart</a></li>
</ul>
</div></template><script>
export default {
  head: {"title":"实验室 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// index-7.vue?f381023a